module.exports = __webpack_public_path__ + "static/img/atpz.6b7ddc1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/atpz.jpeg
// module id = mVi0
// module chunks = 4